import $ from 'jquery'

import Order from './Order'
import OrderSuggestions from '../validation/OrderSuggestions'
import Dropdown from '../components/Dropdown'
import Translation from '../i18n/Translation'
import Util from '../util/Util'
import OrderValidation from '../validation/OrderValidation'

export default class Directmarketing {
  static prefix = 'vol_dm_'

  static _registerEvents () {
    $(document).on('click', '.remove-deliverpoint', Directmarketing._removeDeliverPoint)

    $('#add-delivery-point').click((event) => {
      event.preventDefault()

      Directmarketing._addDeliveryPoint(true)
    })

    $('.dialog-background').on('click', event => {
      $(event.target).siblings('.dialog').find('.close-dialog').trigger('click')
    })

    $('.close-dialog').click((event) => {
      event.preventDefault()

      const toggleElement = event.target.dataset.toggle
      const element = document.getElementById(toggleElement)

      element.classList.add('hidden')

      $(document.body).removeClass('fade')
    })

    $('#dm_preview_to_start').click((event) => {
      localStorage.setItem('vol_dm_preview', false)
      event.preventDefault()
      window.location.href="/direktvermarktung?step=1" 
    })

    $('#dm_preview_to_order').click((event) => {
      localStorage.setItem('vol_dm_preview', false)
      event.preventDefault()
      window.location.href="/bestellprozess?step=1"
    })


    $('#open-dialog').click((event) => {
      const toggleElement = event.target.dataset.elementid
      const element = document.getElementById(toggleElement)

      $('body, html').animate({ scrollTop: 0 }, 500, 'swing')

      // $(window).scrollTop({ top: 0, behavior: 'smooth' })
      element.classList.remove('hidden')

      $(document.body).addClass('fade')
    })
  }

  static _clearDeliveryPointData (index) {
    Object.keys(localStorage)
      .filter(key => key.includes(`[${index}]`))
      .forEach(key => localStorage.removeItem(key))

    Directmarketing._getAllLocalStorageIds().forEach((oldIndex, currentIndex) => {
      Object.keys(localStorage).forEach(key => {
        if (key.includes(`[${oldIndex}]`)) {
          const newKey = key.replace(oldIndex, currentIndex)
          localStorage.setItem(newKey, localStorage[key])

          if (oldIndex !== currentIndex) {
            localStorage.removeItem(key)
          }
        }
      })
    })

    $('#delivery-points').html('')
    Directmarketing._recreateForms(true)
  }

  static _removeDeliverPoint (event) {
    const { deliverypointIndex } = event.target.dataset
    const ids = Array.from(document.getElementsByClassName('consumptionpoint_internal_id')).map(input => input.value)

    if (ids.length > 0) {
      const id = ids[deliverypointIndex]

      $.ajax({
        type: 'POST',
        // eslint-disable-next-line max-len
        url: '/direktmarketing?tx_voltego_directmarketing%5Baction%5D=deleteconsumptionpoint&tx_voltego_directmarketing%5Bcontroller%5D=Dmajax&type=1335898898',
        contentType: 'application/x-www-form-urlencoded',
        data: `consumptionpoint_id=${id}`,
        success: ({ success, message }) => {
          // eslint-disable-next-line no-console
          console.log('success')

          const idInput = document.querySelector(`.consumptionpoint_internal_id[value="${id}"]`)

          if (idInput) {
            idInput.remove()
          }

          Directmarketing._clearDeliveryPointData(deliverypointIndex)
        },
        error: (error) => {
          // eslint-disable-next-line no-console
          console.error(error)
        },
      })

      return
    }

    Directmarketing._clearDeliveryPointData(deliverypointIndex)
  }

  static _addDeliveryPoint (suppressMessage = false) {
    const originalDeliverPoint = document.getElementById('deliver-point-original')
    const deliveryPoints = document.getElementById('delivery-points')

    if (!deliveryPoints) {
      return
    }

    const index = deliveryPoints.querySelectorAll('.card').length

    if (index === 1 && !suppressMessage) {
      const helpDialog = document.getElementById('help-dialog')

      helpDialog.classList.remove('hidden')
      $(document.body).addClass('fade')
    }

    if (index > 0) {
      $('.remove-deliverpoint').removeClass('hidden')
    }
    else {
      $('.remove-deliverpoint').addClass('hidden')
    }

    deliveryPoints.innerHTML += originalDeliverPoint.innerHTML.replace(/#i#/g, index + 1).replace(/#index#/g, index)
    Directmarketing._recreateForms()
  }

  static _getFormInputKeys (key) {
    const fields = [
      ...(document.getElementsByTagName('input') || []),
      ...(document.getElementsByTagName('textarea') || []),
    ]

    switch (key) {
      case 'consumptionpoints':
        return fields
          .filter(input =>
            (input.name.includes(`${Directmarketing.prefix}`) && !input.name.includes('#index#'))
          )
          .map(input => input.name)
          .filter((elem, index, self) => index === self.indexOf(elem))

      case 'overview':
      case 'connectiondata':
      case 'contract':
        return fields
          .filter(input => input.name.includes(`${Directmarketing.prefix}${key}`) && !input.name.includes('#index#'))
          .map(input => input.name)
          .filter((elem, index, self) => index === self.indexOf(elem))

      default:
        return true
    }
  }

  static _registerInputChange () {
    OrderSuggestions.registerEvents()

    $(document).on('change', 'input', async (event, validate = true) => {
      const { name, value, checked } = event.target
      let val = String(value).trim()
      event.target.value = val

      if (name == "vol_dm_contract_company") {
        event.target.value = Order._filterCompanyName(value) 
      }

      const index = Util._getCurrentIndex(name)

      if (index === '#' || index === '#index#') {
        return
      }

      if (event.target.type === 'checkbox') {
        val = checked
      }

      if (name === 'vol_dm_connectiondata_start_date' && !val) {
        event.target.value = Translation.getText('asap')
      }

      if (name.includes('vol_dm_consumptionpoint_meter_type')) {
        val = val ? 'EXPORT' : 'MAIN'
      }

      if (name.includes('consumption_amount')) {
        val = Util.getNumberFromSeparatedNumberString(value)

        OrderValidation.handleConsumptionType(name, Util.getNumberFromSeparatedNumberString(value))

        const inputName = `vol_dm_consumptionpoint_consumption_type[${index}]`

        if (val >= 100000) {
          document.getElementsByName(inputName).forEach(input => {
            input.checked = input.value === 'RLM'
          })

          localStorage.setItem(inputName, 'RLM')

          OrderValidation.hideConsumptionType(false, index)
        }
        else if (val < 60000) {
          document.getElementsByName(inputName).forEach(input => {
            input.checked = input.value === 'SLP'
          })

          localStorage.setItem(inputName, 'SLP')

          OrderValidation.hideConsumptionType(true, index)
        }
      }

      if (name === 'vol_dm_customer_type' && value !== 'private') {
        const indices = Directmarketing._getAllLocalStorageIds()

        indices.forEach((index) => {
          const keyName = `vol_dm_consumptionpoint_consumption_amount[${index}]`
          const val = localStorage.getItem(keyName)

          OrderValidation.handleConsumptionType(keyName, Util.getNumberFromSeparatedNumberString(val))
        })
      }

      localStorage.setItem(name, val)

      if (name.includes('consumption_type') || name.includes('medium_type')) {
        OrderValidation.loadIndustrySectors(name)
      }

      OrderValidation.handleField(name)

      if (name.includes('vol_dm_consumptionpoint_consumption_type')) {
        const index = Util._getCurrentIndex(name)
        const validationName = `vol_dm_consumptionpoint_consumption_amount[${index}]`
        const { success, message } = await OrderValidation.isTypeValid(validationName, localStorage[validationName])

        OrderValidation.setInputError(!success, validationName, message)
      }

      if (validate) {
        const { success, message } = await OrderValidation.validateInput(name, value)

        OrderValidation.setInputError(!success, name, message)
      }
    })

    $(document).on('change', 'textarea', async (event, validate = true) => {
      const { name, value } = event.target
      const { success, message } = await OrderValidation.validateInput(name, value)

      if (validate) {
        OrderValidation.setInputError(!success, name, message)
        localStorage.setItem(`${name}`, value)
      }
    })
  }

  static async _recreateForms (init = false) {
    if (init) {
      Directmarketing._getConsumptionPointsIds()
    }

    const currentPageIndex = window.location.search.substring(window.location.search.indexOf('=') + 1)

    if (currentPageIndex === '1' || !currentPageIndex) {
      await OrderValidation.loadIndustrySectors('init')
    }

    const inputs = [
      ...(document.getElementsByTagName('input') || []),
      ...(document.getElementsByTagName('textarea') || []),
    ]

    inputs.forEach(input => {
      if (
        input.name &&
        !input.name.includes('#index#') &&
        !input.name.includes('vol_dm_connectiondata_internal_id')
      ) {
        const inputValue = localStorage[input.name] || input.value

        if (input.type === 'checkbox' && !input.name.includes('vol_dm_consumptionpoint_meter_type')) {
          input.checked = localStorage[input.name] === 'true'
        }
        else if (input.type === 'radio') {
          const isNotSet = !localStorage[input.name] &&
            Array.from(document.querySelectorAll(`[name="${input.name}"]`)).findIndex(radio => radio === input) === 0

          input.checked = localStorage[input.name] === input.value || isNotSet

          if (isNotSet) {
            localStorage.setItem(input.name, input.value)
          }
        }
        else if (input.type === 'hidden' && input.classList.contains('hidden-dropdown')) {
          input.value = inputValue

          Dropdown._changeSelected(input.name, inputValue)
        }
        else if (input.name.includes('vol_dm_consumptionpoint_consumption_amount')) {
          input.value = Util.getSeparatedNumberString(inputValue)
        }
        else if (input.name.includes('vol_dm_consumptionpoint_meter_type') && input.value === 'EXPORT') {
          input.checked = localStorage[input.name] === 'EXPORT'
        }
        else {
          input.value = inputValue
        }

        OrderValidation.handleField(input.name)
      }

      if (!localStorage[input.name] && !input.name.includes('#index#')) {
        $(input).trigger('change', false)
      }

      if (input.name.includes('vol_dm_connectiondata_internal_id')) {
        localStorage.setItem(input.name, input.value)
      }
    })
  }

  static _getAllLocalStorageIds () {
    return Object.keys(localStorage)
      .filter(key => /^vol_dm_\w*\[\d+\]/.test(key))
      .map(key => Number(key.slice(-2, -1)))
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort()
  }

  static _getConsumptionPointsIds () {
    let ids = [ ...(document.getElementsByClassName('consumptionpoint_internal_id') || []) ].map(input => input.value)

    ids = ids.length === 0 ? Directmarketing._getAllLocalStorageIds() : ids

    if (ids.length === 0) {
      Directmarketing._addDeliveryPoint()
    }
    else {
      ids.forEach((id, index) => {
        Directmarketing._addDeliveryPoint(true)
      })
    }
  }

  static _loadingAnimation (show) {
    if (show) {
      $('#loading-dialog').removeClass('hidden')
      $(document.body).addClass('fade')

      const step = window.location.search.split('=')[1] || '1'

      if (step === '1') {
        $('.step-1-loading-text').removeClass('hidden')
        $('.step-4-loading-text').addClass('hidden')
      }
      else {
        $('.step-1-loading-text').addClass('hidden')
        $('.step-4-loading-text').removeClass('hidden')
      }
    }
    else {
      $('#loading-dialog').addClass('hidden')
      $(document.body).removeClass('fade')
    }
  }

  static _handleErrorDialog (show, message, description, icon, previewOptions) {
    if (show) {
      $('#error-dialog').removeClass('hidden')
      $(document.body).addClass('fade')

      if (message) {
        $('#error-dialog .dialog-title').html(message)
      }

      if (previewOptions == true) {
        $('#error-dialog .preview-options').removeClass('hidden')
      } else {
        $('#error-dialog .preview-options').addClass('hidden')
      }

      if (description) {
        $('#error-dialog .dialog-description').html(description)
      }

      if (icon) {
        $('.dialog-icon').addClass('hidden')
        $(`#icon-${icon}`).removeClass('hidden')
      }
    }
    else {
      $('#error-dialog').addClass('hidden')
      $(document.body).removeClass('fade')
      $('#error-dialog .dialog-title').html(Translation.getText('order_dialog_message_default'))
      $('#error-dialog .dialog-description').html(Translation.getText('order_dialog_description_default'))
      $('.dialog-icon').addClass('hidden')
      $('#icon-default').removeClass('hidden')
    }
  }

  static async _validateForm (inputKeys) {
    const validation = []

    for (const key of inputKeys) {
      const { success, message } = await OrderValidation.validateInput(key, localStorage[key])

      OrderValidation.setInputError(!success, key, message)

      validation.push(success)
    }

    // DEBUG-DISABLE-HERE
    return !validation.includes(false)
  }

  static _setAddressError (hasError, consumptionPointsIndices) {
    // remove all (old) messages
    $('.vol_dm_consumptionpoint_address').each(function () {
      $(this).text('')
    })

    if (hasError) {
      consumptionPointsIndices.forEach(index => {
        $(`.vol_dm_consumptionpoint_address_${index}`).text(Translation.getText('no_operators_address'))
      })
    }
  }

  static async _handlePreviewMode() {
    let message = ' '
    let description = 'Um eine Vertragsanfrage zur Direktvermarktung zu senden, müssen Sie Bestandskunde für die Strombelieferung sein. Das ermöglicht uns die einfache und komplette Abrechnung der produzierten Energiemengen.'
    let icon = 'no-operators'
    Directmarketing._handleErrorDialog(true, message, description, icon, true)
  }

  static async _submitFunction (inputPrefix, nextStopId) {
    const formInputKeys = Directmarketing._getFormInputKeys(inputPrefix)
    const validationSuccessful = await Directmarketing._validateForm(formInputKeys)

    if (validationSuccessful) {
      let inputValues = {}
      let dataString = `vol_cookie_consent_allowed=${localStorage.vol_cookie_consent_allowed}&`
      formInputKeys.forEach((key, index) => {
        inputValues = {
          ...inputValues,
          [key]: localStorage[key],
        }

        dataString += `${key}=${encodeURIComponent(localStorage[key])}${index !== formInputKeys.length - 1 ? '&' : ''}`
      })

      // eslint-disable-next-line max-len
      const url = `/direktvermarktung?tx_voltego_directmarketing%5Baction%5D=${inputPrefix}&tx_voltego_directmarketing%5Bcontroller%5D=Dmajax&type=1335898898`

      Directmarketing._loadingAnimation(true)

      $.ajax({
        type: 'POST',
        url,
        contentType: 'application/x-www-form-urlencoded',
        data: dataString,
        success: ({ success, message, display_message: displayMessage, ...rest }) => {
          Directmarketing._setAddressError(false)

          if (success) {
            if (nextStopId === 'finish') {
              localStorage.setItem('vol_dm_finish_status', message)
              window.location = '/'
              return
            }

            window.location.search = `?step=${nextStopId}`
          }
          else {
            Directmarketing._loadingAnimation(false)

            if (rest.status_code === 400 || !displayMessage) {
              let message = Translation.getText('order_dialog_message_default')
              let description = Translation.getText('order_dialog_description_default')
              let icon = 'default'

              switch (rest.error_code) {

                case 10:
                  message = Translation.getText('order_dialog_message_invalid-address')
                  description = Translation.getText('order_dialog_description_invalid-address')
                  icon = 'no-operators'

                  Directmarketing._setAddressError(true, rest.consumption_points)
                  break

                case 11:
                  message = Translation.getText('order_dialog_message_no-operators')
                  description = Translation.getText('order_dialog_description_no-operators')
                  icon = 'no-operators'
                  break

                case 12:
                  message = Translation.getText('order_dialog_message_no-tariffs')
                  description = Translation.getText('order_dialog_description_no-tariffs')
                  icon = 'no-operators'
                  break

                case 42:
                  message = 'Unbekannter Kunde'
                  description = 'Die Kunden- und/oder Vertragsnummer ist leider nicht bekannt.'
                  icon = 'no-operators'
                  break
              }

              Directmarketing._handleErrorDialog(true, message, description, icon)

              return
            }

            Directmarketing._handleErrorDialog(true, displayMessage)
          }
        },
        error: (error) => {
          Directmarketing._loadingAnimation(false)
          // eslint-disable-next-line no-console
          console.error(error)
          Directmarketing._handleErrorDialog(true)
        },
      })
    }
  }

  static _onSubmit () {

    $('#submit').click((event) => {
      event.preventDefault()

      const currentPageIndex = window.location.search.substring(window.location.search.indexOf('=') + 1)

      switch (currentPageIndex) {
        case '1':
          Directmarketing._submitFunction('consumptionpoints', 2)
          break
        case '2':
          if (localStorage.getItem('vol_dm_preview') == true) {
            Directmarketing._handlePreviewMode()
          } else {
            window.location.search = '?step=3'
          }
          break
        case '3':
          Directmarketing._submitFunction('contract', 4)
          break
        case '4':
          Directmarketing._submitFunction('connectiondata', 5)
          break
        case '5':
          Directmarketing._submitFunction('overview', 'finish')
          break
        default:
          Directmarketing._submitFunction('consumptionpoints', 2)
          break
      }
    })
  }

  static _setOverviewData () {

    let doc = ""
    $('.voltego-text-footer a').each( function(index) {
      let label = this.innerText;
      if (label.indexOf("Tarif") != -1)
        doc = this.href
    });

    let link = $('#vol_dm_overview_agb_container a')[0]
    if (link)
      link.href= doc

    $('.vol_dm_contract_firstname').html(localStorage.vol_dm_contract_firstname)
    $('.vol_dm_contract_lastname').html(localStorage.vol_dm_contract_lastname)
    $('.vol_dm_contract_phone').html(localStorage.vol_dm_contract_phone)
    $('.vol_dm_contract_email').html(localStorage.vol_dm_contract_email)

    $('.vol_dm_contract_company').html(localStorage.vol_dm_contract_company)

    if (localStorage.vol_dm_contract_company_type !== 'Einzelunternehmen') {
      $('.vol_dm_contract_company_type').html(localStorage.vol_dm_contract_company_type)
    }

    if (localStorage.vol_dm_contract_company_type === 'GmbH-Co-KG') {
      $('.vol_dm_contract_company_type').html('GmbH & Co. KG')
    }

    $('.vol_dm_contract_city').html(localStorage.vol_dm_contract_city)
    $('.vol_dm_contract_postal_code').html(localStorage.vol_dm_contract_postal_code)
    $('.vol_dm_contract_street').html(localStorage.vol_dm_contract_street)
    $('.vol_dm_contract_house_number').html(localStorage.vol_dm_contract_house_number)
  }

  static _clear () {
    Object
      .keys(localStorage)
      .filter(key => key.includes('vol_dm'))
      .forEach(key => localStorage.removeItem(key))
  }

  static _handleReferrer () {
    const { referrer } = document

    if (referrer && !referrer.includes('direktvermarktung')) {
      localStorage.setItem('direktmarketing_referrer', referrer + window.location.hash)

      // on entering the order process clear old data
      Directmarketing._clear()
    }

    const storedReferer = localStorage.getItem('direktmarketing_referrer') || '/'

    $('#abort_link').attr('href', storedReferer)
  }

  static init () {

    const dmWrapper = document.querySelector('#form-dm')

    if (dmWrapper) {
      OrderValidation.setMode("dm")

      if (document.querySelector('#abort_link')) {
        Directmarketing._handleReferrer()
      }

      Directmarketing._recreateForms(true)
      Directmarketing._registerEvents()
      Directmarketing._onSubmit()
      Directmarketing._registerInputChange()
      Directmarketing._setOverviewData()
      OrderValidation.handleField()

      if (localStorage.getItem('vol_dm_preview') == true) {
        let el = document.getElementById('ordernav-title')
        el.innerText="Angebotsindikation"
      }
    }
  }
}
